import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaCrosshairs, FaGem } from 'react-icons/fa6';
import { IoEyeSharp } from 'react-icons/io5';
import './MissionVision.css'; // Importing the updated scoped stylesheet
import { Link } from 'react-router-dom';

const MissionVision = () => {
  return (
    <section className="mission-vision-section">
      <Container>
        {/* Header Row */}
        <Row className="align-items-end mb-3">
          <Col md={9}>
            <span className="text-muted text-uppercase fw-semibold sub-title">
              About Us
            </span>
            <h2 className="heading_text">
            Our Mission, Vision & Core Values
            </h2>
          </Col>
          <Col md={3} className="text-md-end text-start mt-3 mt-md-0">
            <Link to={"/about-us"}>
              <Button className="btn-read-more border-0 px-4 py-2 text-uppercase fw-bold">
                Read More
              </Button>
            </Link>
          </Col>
        </Row>

        {/* Cards Row */}
        <Row className="g-4 justify-content-center">
          {/* Mission Card */}
          <Col lg={4} md={6}>
            <div className="km-card text-center h-100 p-4">
              <div className="icon-wrapper">
                <FaCrosshairs className="card-icon icon-target" />
                <span className="icon-dot"></span>
              </div>
              <h4 className="card-title fw-bold">Mission</h4>
              <p className="card-text text-muted">
                Our mission is to deliver innovative CCTV solutions that improve
                safety and peace of mind with integrity and excellence.
              </p>
            </div>
          </Col>

          {/* Vision Card */}
          <Col lg={4} md={6}>
            <div className="km-card text-center h-100 p-4">
              <div className="icon-wrapper">
                <IoEyeSharp className="card-icon" />
                <div className="vision-lashes">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <h4 className="card-title fw-bold">Vision</h4>
              <p className="card-text text-muted">
                To foster innovation, drive sustainable growth, and create
                long-term value for our customers, employees, and communities.
              </p>
            </div>
          </Col>

          {/* Core Value Card */}
          <Col lg={4} md={6}>
            <div className="km-card text-center h-100 p-4">
              <div className="icon-wrapper">
                <FaGem className="card-icon" />
                <div className="value-lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <h4 className="card-title fw-bold">Core Value</h4>
              <p className="card-text text-muted">
                Our Core values—Integrity, Innovation, Excellence, and
                Collaboration—drive us to provide trustworthy, innovative
                security
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MissionVision;